import { Dispatch, useCallback } from "react";
import { HeldEmailQueueAction } from "./useHeldEmailQueueState";

export function useHeldEmailQueueNavigation(
  dispatch: Dispatch<HeldEmailQueueAction>
) {
  const select = useCallback(
    (value: Set<string>) => dispatch({ type: "selection", value }),
    [dispatch]
  );
  const view = useCallback(
    (value: string) => dispatch({ type: "detail", value }),
    [dispatch]
  );
  return { select, view };
}

export function useHeldEmailQueueActions(
  dispatch: Dispatch<HeldEmailQueueAction>
) {
  const release = useCallback(
    (ids: string[]) =>
      dispatch({ type: "action", value: { type: "release", ids } }),
    [dispatch]
  );
  const cancel = useCallback(
    (ids: string[]) =>
      dispatch({ type: "action", value: { type: "cancel", ids } }),
    [dispatch]
  );
  return { release, cancel };
}
